export default function () {
  return {
    errors: {},
    customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['image']],
    terms: {
      id: null,
      content: '',
    },
  }
}
